var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(_vm.isIE)?_c('unsupported-browser'):(_vm.isMobile && !_vm.$store.state.app.ignoreUnsupportedDevices)?_c('unsupported-device'):_c(_vm.layout,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }